declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_dict_foo extends $mol_object {
		bar( ): ({ 
			'alpha': number,
			'beta': string,
		}) 
	}
	
}

//# sourceMappingURL=structural_dict.view.tree.d.ts.map